import { memo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { FloatingDropZoneItem } from "@circle-react-shared/BuilderUI/FloatingDropZone/FloatingDropZoneItem";

export const FloatingDropZones = memo(() => {
  const isDraggingEnabled = useBuilderStore(state => state.isDraggingEnabled);
  const dropZonePositions = useBuilderStore(state => state.dropZonePositions);

  if (!isDraggingEnabled) return null;

  return (
    <div
      className="pointer-events-none absolute left-0 top-0 z-10 h-full w-full"
      data-testid="builder-ui-floating-drop-zones"
    >
      {dropZonePositions.map(position => (
        <FloatingDropZoneItem
          key={`${position.path}:${position.index}`}
          {...position}
        />
      ))}
    </div>
  );
});

FloatingDropZones.displayName = "FloatingDropZones";
